import useGeneralSettingsStore from '../stores/GeneralSettings/useGeneralSettingsStore';
import configureGridItemWidth from '../utils/configureGridItemsWidth';

const useGetGridItemWidth = () => {
  const {
    generalSettings: { gridSize },
  } = useGeneralSettingsStore();

  return {
    gridItemWidth: configureGridItemWidth(gridSize),
  };
};

export default useGetGridItemWidth;
